import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;

interface IInputRangePickerProps extends RangePickerProps {

}

export default function InputRangePicker ({
    showTime,
    picker,
    ...props
}:IInputRangePickerProps) {
    return <RangePicker
        {...props}
        format={props.format === undefined ? {
                format : picker === "month" ? "MM/YYYY" : (showTime === true ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"),
                type: 'mask'
            } : props.format
        }
        showTime={showTime}
        picker={picker}
    />
}